import NietErnstigeBloedingenOnderVka from "../../../../src/client/lta-antistolling/niet-ernstige-bloedingen-onder-vka.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  NietErnstigeBloedingenOnderVka,
  ChartCollapse,
  React
};